export default __webpack_public_path__ + "static/media/common.413a249f.svg";